import {Provider} from '@oilstone/container';

export default new Provider().register(container => {
    container.singleton('keyValues', () => {
        return container.resolve('resourceRegistry').find('key-values').repository.categorised();
    });
});
